import React, { useMemo, useState } from 'react';
import styles from './Pagination.module.scss';
import IconDown from '../../assets/icons/chevron_down.svg?react';

type Props = {
  totalItems: number;
  perPage?: number;
  onPageChange?: (page: number) => void;
  currentPage: number;
};

function Pagination(props: Props) {
  const { totalItems, perPage = 10, onPageChange, currentPage } = props;

  const [perOnePage] = useState(perPage);

  const pages = useMemo(() => {
    const totalPages = Math.ceil(totalItems / perOnePage);
    return new Array(totalPages).fill(0).map((_, i) => i + 1);
  }, [perOnePage, totalItems]);

  const handleLeft = () => {
    const p = currentPage - 1;
    if (p > 0) {
      changePage(p);
    }
  };

  const handleRight = () => {
    const p = currentPage + 1;
    if (pages.length >= p) {
      changePage(p);
    }
  };

  const handleChangePage = (page: number) => () => {
    changePage(page);
  };

  const changePage = (page: number) => {
    onPageChange && onPageChange(page);
  };

  if (totalItems === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.pagesWrapper}>
        <div className={styles.leftBtn} onClick={handleLeft}>
          <IconDown/>
        </div>
        <div className={styles.pages}>
          {pages.map(p => {
            const active = currentPage === p;
            return (
              <div className={`${styles.page} ${active ? styles.active : ''}`} key={p} onClick={handleChangePage(p)}>
                {p}
              </div>
            );
          })}
        </div>
        <div className={styles.rightBtn} onClick={handleRight}>
          <IconDown/>
        </div>
      </div>
      <div className={styles.countText}>
        Showing {(currentPage - 1) * perPage + 1} - {Math.min(currentPage * perPage, totalItems)} of {totalItems}
      </div>
    </div>
  );
}

export default Pagination;
